import React, { useState } from 'react';

interface ProfilePictureTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ProfilePictureTermsModal({ isOpen, onClose, onConfirm }: ProfilePictureTermsModalProps) {
  const [agreed, setAgreed] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-white dark:bg-gray-800 border border-slate-200 dark:border-slate-800 rounded-2xl w-full max-w-md overflow-hidden shadow-2xl flex flex-col p-6 animate-slide-up">
        
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            📸 Profilbild hochladen
          </h3>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="text-sm text-slate-600 dark:text-slate-350 space-y-4 mb-6 leading-relaxed">
          <p>
            Bevor du ein Profilbild hochladen kannst, musst du die folgenden Nutzungsbedingungen bestätigen:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Es dürfen ausschließlich <strong>persönliche Profilfotos</strong> hochgeladen werden, die dich selbst abbilden.</li>
            <li>Es dürfen <strong>keine KI-bearbeiteten oder KI-generierten Fotos</strong> verwendet werden.</li>
            <li>Alle hochgeladenen Bilder werden stichprobenartig kontrolliert und bei Verstößen ohne Vorankündigung gelöscht.</li>
          </ul>
        </div>

        {/* Agree Checkbox */}
        <label className="flex items-start gap-3 cursor-pointer mb-6 select-none bg-slate-50 dark:bg-slate-950 p-3 rounded-lg border border-slate-200 dark:border-slate-800">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="mt-1 w-4 h-4 text-blue-600 border-slate-300 dark:border-slate-800 rounded focus:ring-blue-500"
          />
          <span className="text-xs text-slate-700 dark:text-slate-300">
            Ich habe die Bedingungen gelesen und bestätige, dass mein Foto diesen Anforderungen entspricht.
          </span>
        </label>

        {/* Actions */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-850 text-slate-700 dark:text-slate-300 rounded-lg text-sm font-semibold transition-all"
          >
            Abbrechen
          </button>
          <button
            onClick={() => {
              if (agreed) onConfirm();
            }}
            disabled={!agreed}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-40 disabled:hover:bg-blue-600 text-white rounded-lg text-sm font-semibold transition-all shadow-md shadow-blue-900/20"
          >
            Fortfahren
          </button>
        </div>

      </div>
    </div>
  );
}
